import api from './api';

export default class AvaliacoesService {
  static id = null;

  constructor() {
    throw 'Não é possível instanciar AvaliacoesService';
  }

  static async lista(id) {
    const endpoint = mergeEndpoint(id);
    return await api.get(endpoint);
  }
}

const mergeEndpoint = id => {
  return `avaliacoes-periodicas/avaliados/${id}/avaliacoes-periodicas/competencias`;
};



// WEBPACK FOOTER //
// ./src/services/avaliacoesService.js